module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-12 paddingLeft50px"
  }, [_c('div', {
    staticClass: "nv-list"
  }, [_c('div', [_c('div', {
    staticClass: "nv-list-toolbar"
  }, [_c('div', {
    staticClass: "nv-list-filter"
  }, [_c('label', {
    attrs: {
      "for": "appStatus"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('nv-select', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "id": "appStatus"
    },
    on: {
      "change": _vm.filterListByStatus
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "deployed"
    }
  }, [_vm._v("Deployed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Changes pending deployment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "never"
    }
  }, [_vm._v("Never deployed")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "nv-list-filter"
  }, [_c('label', {
    attrs: {
      "for": "folderName"
    }
  }, [_vm._v("Folder")]), _vm._v(" "), _c('nv-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "id": "folderName",
      "disabled": _vm.disableFolderSelection
    },
    on: {
      "change": _vm.filterListByFolder
    },
    model: {
      value: (_vm.folderName),
      callback: function($$v) {
        _vm.folderName = $$v
      },
      expression: "folderName"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All folders")]), _vm._v(" "), _vm._l((_vm.folderList), function(data) {
    return _c('option', {
      key: data,
      domProps: {
        "value": data
      }
    }, [_vm._v(_vm._s(data))])
  })], 2)], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openFolderAddModel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" New folder")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary nv-list-toolbar__end",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadTranslationPopupClick()
      }
    }
  }, [_vm._v("Upload Translation")])]), _vm._v(" "), (_vm.showFolderAddModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "ModelFolderAdd"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "200PX",
      "max-width": "600px"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Create New Folder")])]
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Folder Name")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObjAdd.folderName),
        expression: "gRowObjAdd.folderName"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submittedAddFolder && !_vm.$v.gRowObjAdd.folderName.required
      },
      attrs: {
        "type": "text",
        "id": "floderNameNew",
        "placeholder": "Type name here"
      },
      domProps: {
        "value": (_vm.gRowObjAdd.folderName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.gRowObjAdd, "folderName", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submittedAddFolder && !_vm.$v.gRowObjAdd.folderName.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please enter folder name.")]) : _vm._e(), _vm._v(" "), (_vm.errorFloderNameAlradyExist) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "font-size": "initial"
      }
    }, [_vm._v("Folder name already exists")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group pull-right"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.closeFolderAddModel
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.AddFolderName
      }
    }, [_vm._v("Submit")])])])])]
  })], 2)], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.deployedColumns,
      "rows": _vm.deployedApps,
      "totalRows": _vm.deployedAppsCount,
      "pagination-options": {
        enabled: true,
        perPage: 20
      }
    },
    on: {
      "on-page-change": _vm.onPageChangeForDeployedApps,
      "on-sort-change": _vm.onSortChangeForDeployedApps,
      "on-column-filter": _vm.onColumnFilterForDeployedApps,
      "on-per-page-change": _vm.onPerPageChangeForDeployedApps
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'name') ? _c('span', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + " "), (props.row.metaData && props.row.metaData.is_new_conversation) ? _c('i', {
          staticClass: "fa fa-refresh fa-fw",
          staticStyle: {
            "cursor": "default"
          },
          attrs: {
            "title": "Synced across all dashboards"
          }
        }) : _vm._e()]) : (!_vm.productionMode && props.column.field == 'deployedDate') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (_vm.productionMode && props.column.field == 'releasedDate') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (props.column.field == 'copy') ? _c('span', [_c('i', {
          staticClass: "fa fa-copy",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.openConversationCopyModel(props.row)
            }
          }
        })]) : (props.column.field == 'folderName') ? _c('span', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                      ")]) : (props.column.field == 'download') ? _c('span', [_c('button', {
          staticClass: "btn btn-primary",
          on: {
            "click": function($event) {
              return _vm.downloadCsvData('deployedApps', props.index)
            }
          }
        }, [_vm._v("CSV")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary",
          on: {
            "click": function($event) {
              return _vm.downloadJson('deployedApps', props.index)
            }
          }
        }, [_vm._v("JSON")])]) : (props.column.field == 'status') ? _c('span', [(props.row.deployed) ? _c('span', {
          staticClass: "nv-status nv-status--deployed",
          attrs: {
            "title": "The latest save is deployed"
          }
        }, [_vm._v("Deployed")]) : (props.row.everDeployed) ? _c('span', {
          staticClass: "nv-status nv-status--pending",
          attrs: {
            "title": "Deployed before, but the latest saved changes aren't deployed yet"
          }
        }, [_vm._v("Changes pending deployment")]) : _c('span', {
          staticClass: "nv-status nv-status--draft",
          attrs: {
            "title": "Saved but never deployed"
          }
        }, [_vm._v("Never deployed")])]) : (props.column.field == 'savedDate') ? _c('span', [_vm._v("\n                          " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                        ")]) : (props.column.field == 'release') ? _c('span', [(!props.row.deployed) ? _c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": function($event) {
              return _vm.syncappAcrossInstances(props.index)
            }
          }
        }, [_vm._v("Release")]) : _vm._e()]) : (props.column.field == 'organize') ? _c('span', [_c('i', {
          staticClass: "fa fa-folder fa-2x",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.openFolderMoveModel(props.row)
            }
          }
        })]) : (props.column.field == 'edit') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("update?app=" + (props.row.id))
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-comments-o",
      "title": "No conversations found",
      "hint": "Try changing the filters, or create a new conversation.",
      "action-label": "Create conversation",
      "action-to": "/conversation/create"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)]), _vm._v(" "), (_vm.showFolderMoveModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "ModelFolderMove"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "230PX",
      "max-width": "600px"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Move To Folder")])]
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("App Name")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.appName) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Choose Folder")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('nv-select', {
      staticClass: "form-control",
      attrs: {
        "id": "folderNameMove"
      },
      model: {
        value: (_vm.gRowObjMove.folderName),
        callback: function($$v) {
          _vm.$set(_vm.gRowObjMove, "folderName", $$v)
        },
        expression: "gRowObjMove.folderName"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Choose an option--")]), _vm._v(" "), _vm._l((_vm.folderList), function(data) {
      return _c('option', {
        key: data,
        domProps: {
          "value": data,
          "selected": data === _vm.gRowObjMove.folderName
        }
      }, [_vm._v(_vm._s(data))])
    })], 2)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group pull-right"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.closeFolderMoveModel
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.moveToFolder
      }
    }, [_vm._v("Submit")])])])])]
  })], 2)], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  })])]) : _vm._e()])])])])])])])]), _vm._v(" "), (_vm.showConversationCopyModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "ConversationCopy"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "300PX",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Copy Conversation")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Current App Name")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8 control-label",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.conversationToCopy.name) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "instance"
      }
    }, [_vm._v("Choose Instance(s)")]), _vm._v(" "), _c('div', {
      staticClass: "instance-wrapper col-sm-8"
    }, _vm._l((_vm.instances), function(instance) {
      return _c('div', {
        key: instance.value,
        staticClass: "instance-checkbox"
      }, [_c('label', {
        staticClass: "checkbox-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.gRowObjConversationCopy.instance),
          expression: "gRowObjConversationCopy.instance"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": instance.value,
          "checked": Array.isArray(_vm.gRowObjConversationCopy.instance) ? _vm._i(_vm.gRowObjConversationCopy.instance, instance.value) > -1 : (_vm.gRowObjConversationCopy.instance)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.gRowObjConversationCopy.instance,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = instance.value,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.gRowObjConversationCopy, "instance", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.gRowObjConversationCopy, "instance", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.gRowObjConversationCopy, "instance", $$c)
            }
          }
        }
      }), _vm._v(_vm._s(instance.name) + "\n                    ")])])
    }), 0), _vm._v(" "), (_vm.submittedConversationCopy && !_vm.$v.gRowObjConversationCopy.instance.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please choose instance(s).")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label radio-inline required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("New App Name")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObjConversationCopy.name),
        expression: "gRowObjConversationCopy.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "name",
        "placeholder": "New App Name"
      },
      domProps: {
        "value": (_vm.gRowObjConversationCopy.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.gRowObjConversationCopy, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submittedConversationCopy && !_vm.$v.gRowObjConversationCopy.name.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please enter conversation name.")]) : _vm._e(), _vm._v(" "), (_vm.submittedConversationCopy && !_vm.$v.gRowObjConversationCopy.name.conversationNameRegex) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v(" The conversation name can only contain underscore, dash and alphanumeric characters.")]) : _vm._e()])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeConversationCopyModel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkConversationAlreadyExists
    }
  }, [_vm._v("Copy")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showConfirmMessage) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "200PX",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Alert")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("You are about to overwrite an existing conversation in instance(s) "), _c('b', [_vm._v(_vm._s(_vm.instanceWarning))]), _vm._v(". Do you want to continue?")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.CopyConversationAlertNoClick
    }
  }, [_vm._v("No, I'll rename it")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.CopyConversationAlertYesClick
    }
  }, [_vm._v("Yes, copy & overwrite")])])])])])]) : _vm._e(), _vm._v(" "), ((!_vm.showConfirmMessage) && _vm.showWarningMessage) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Warning")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("There are some conversations/keyword linked with the app which you are trying to " + _vm._s(_vm.operation) + ". Please make sure to perform copy below apps in respective instance(s).")]), _vm._v(" "), _c('div', {
      staticClass: "warning-text-red"
    }, [_vm._v("Are you sure you want to proceed without these?")]), _vm._v(" "), _c('div', {
      staticClass: "copy-warning-app-container"
    }, _vm._l((_vm.connectedAppDataForCopy), function(data) {
      return _c('div', {
        key: data.instanceName
      }, [(data.appsNotPresent.length || data.appsPresentButNeverDeployed.length || data.keywordsNotPresent.length || data.messageTemplatesNotPresent.length) ? _c('div', [_c('div', {
        staticStyle: {
          "font-weight": "bold",
          "margin-top": "10px"
        }
      }, [_vm._v(_vm._s(data.instanceName) + ": ")]), _vm._v(" "), (data.appsPresentButNeverDeployed.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                    Conversation(s) present but never deployed:\n                    "), _c('ul', _vm._l((data.appsPresentButNeverDeployed), function(app) {
        return _c('li', {
          key: app
        }, [_vm._v("\n                        " + _vm._s(app) + "\n                      ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (data.appsNotPresent.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                    Conversation(s) not present:\n                    "), _c('ul', _vm._l((data.appsNotPresent), function(app) {
        return _c('li', {
          key: app
        }, [_vm._v("\n                        " + _vm._s(app) + "\n                      ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (data.keywordsNotPresent.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                      Keyword(s) not present:\n                    "), _c('ul', _vm._l((data.keywordsNotPresent), function(keyword) {
        return _c('li', {
          key: keyword
        }, [_vm._v("\n                        " + _vm._s(keyword) + "\n                      ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (data.messageTemplatesNotPresent.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                      Message Template(s) not present:\n                    "), _c('ul', _vm._l((data.messageTemplatesNotPresent), function(template) {
        return _c('li', {
          key: template
        }, [_vm._v("\n                        " + _vm._s(template) + "\n                      ")])
      }), 0)]) : _vm._e()]) : _vm._e()])
    }), 0)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.CopyConversationWarningNoClick
    }
  }, [_vm._v("No, let me check the conversation")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copyConversationWarningYesClick
    }
  }, [_vm._v("Yes, proceed with it")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showTranslationMissingMessage) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Warning")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("Below are the stages missing mentioned translations:")]), _vm._v(" "), _c('div', {
      staticClass: "copy-warning-app-container"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.missingStages), function(item, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(item.stage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.msgSet))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.missingLang.join(',  ')))])])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "warning-text-red",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v("Do you want to proceed with current configuration?")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.translationMissingWarningNoClick
    }
  }, [_vm._v("No, let me check the conversation")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.translationMissingWarningYesClick
    }
  }, [_vm._v("Yes, proceed with it")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showUploadTranslationModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "translate"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "420px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Upload Translation")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "height": "100%"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "instance"
      }
    }, [_vm._v("Choose Instance(s)")]), _vm._v(" "), _c('div', {
      staticClass: "instance-wrapper col-sm-8"
    }, _vm._l((_vm.instances), function(instance) {
      return _c('div', {
        key: instance.value,
        staticClass: "instance-checkbox"
      }, [_c('label', {
        staticClass: "checkbox-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.gRowObjUploadTranslation.instance),
          expression: "gRowObjUploadTranslation.instance"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": instance.value,
          "checked": Array.isArray(_vm.gRowObjUploadTranslation.instance) ? _vm._i(_vm.gRowObjUploadTranslation.instance, instance.value) > -1 : (_vm.gRowObjUploadTranslation.instance)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.gRowObjUploadTranslation.instance,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = instance.value,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.gRowObjUploadTranslation, "instance", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.gRowObjUploadTranslation, "instance", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.gRowObjUploadTranslation, "instance", $$c)
            }
          }
        }
      }), _vm._v(_vm._s(instance.name) + "\n                    ")])])
    }), 0), _vm._v(" "), (_vm.submittedTranslationUpload && !_vm.$v.gRowObjUploadTranslation.instance.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please choose instance(s).")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label radio-inline required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Destination language(s)")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8 language-treeselect"
    }, [_c('treeselect', {
      staticStyle: {
        "min-width": "200px"
      },
      attrs: {
        "placeholder": "--Choose languages--",
        "multiple": true,
        "options": _vm.countryLanguages
      },
      model: {
        value: (_vm.gRowObjUploadTranslation.selectedLanguages),
        callback: function($$v) {
          _vm.$set(_vm.gRowObjUploadTranslation, "selectedLanguages", $$v)
        },
        expression: "gRowObjUploadTranslation.selectedLanguages"
      }
    }), _vm._v(" "), (_vm.submittedTranslationUpload && !_vm.$v.gRowObjUploadTranslation.selectedLanguages.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please choose destination(s).")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label radio-inline required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Import file")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8",
      staticStyle: {
        "margin-top": "7px"
      }
    }, [_c('div', [_c('input', {
      attrs: {
        "type": "file",
        "id": "csvFile",
        "accept": ".csv"
      },
      on: {
        "change": _vm.onCsvFileChange
      }
    })]), _vm._v(" "), (_vm.submittedTranslationUpload && !_vm.csvData.length) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please select valid CSV file.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "warning-text-red"
    }, [_vm._v("Note: If the app isn't synced across instances, this only updates the same region of staging or production.")])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeTranslateModel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.proceedTranslateModel
    }
  }, [_vm._v("Translate")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showTranslatedData) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Success")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._t("body", function() {
    return [_vm._l((Object.entries(_vm.translatedData)), function(ref, index) {
      var instance = ref[0];
      var apps = ref[1];

      return _c('div', {
        key: index
      }, [_vm._v("\n              Updated app(s) on "), _c('b', [_vm._v(_vm._s(_vm.instanceNames[instance]))]), _vm._v(" : " + _vm._s(apps.map(function (item) { return item.name; }).join(', ')) + "\n            ")])
    }), _vm._v(" "), _c('div', {
      staticClass: "warning-text-red"
    }, [_vm._v("Note: Please check the updated translations in the apps and release them to apply the changes.")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.missingTranslatedData.length) ? _c('div', [_c('div', [_vm._v("Below are the apps with missing translations. Please check it out.")]), _vm._v(" "), _c('div', {
      staticClass: "copy-warning-app-container"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.missingTranslatedData), function(item, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(item.region))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.app))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.stage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.msgSet))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.missingLang.join(',  ')))])])
    })], 2)])]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.translationDataOkClick
    }
  }, [_vm._v("OK")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.processing) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      CONVERSATIONS\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("View All Conversations")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Stage name")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Missing Translation(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("App name")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Stage name")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Missing Translation(s)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-96c2ed2e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/conversation/view.vue
// module id = onX4
// module chunks = 1